// Badge — the small uppercase status chip (`.orb-badge`). Tone maps to a
// token colour so severity/status chips read consistently in both themes.
// Replaces ~40 hand-rolled `orb-badge` usages with explicit tones.
import { HTMLAttributes } from 'react';
import { cn } from './cn';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-bg-inset text-fg-muted border border-border',
  accent: 'bg-accent/10 text-accent border border-accent/30',
  success: 'bg-success/10 text-success border border-success/30',
  warning: 'bg-warning/10 text-warning border border-warning/30',
  danger: 'bg-danger/10 text-danger border border-danger/30',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  readonly tone?: BadgeTone;
}

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return <span className={cn('orb-badge', toneClasses[tone], className)} {...rest} />;
}
